export const UPLOAD_PROJECT_REQUEST: 'UPLOAD_PROJECT_REQUEST' =
  'UPLOAD_PROJECT_REQUEST';
export const UPLOAD_PROJECT_SUCCESS: 'UPLOAD_PROJECT_SUCCESS' =
  'UPLOAD_PROJECT_SUCCESS';
export const UPLOAD_PROJECT_FAILURE: 'UPLOAD_PROJECT_FAILURE' =
  'UPLOAD_PROJECT_FAILURE';
